import { immerSet, get } from './useStore'

export const locationUpdate = locId => immerSet(state => { state.locId = locId })

export const getLocId = () => get()['locId']
